import classnames from 'classnames';
import { ReactSVG } from 'react-svg';
import { getStaticHost } from './helpers/getStaticHost';
import styles from './index.module.less';
import themeToClassNames from '../../../core/themeToClassNames';
import isClient from '../../../utilities/isClient';
import modifiersToClassNames from '../../../core/modifiersToClassNames';
import { Size } from '../../../core/enums';
import type { IconProps } from '../../../core/types';

function getSvgPath({
  directory,
  imageName,
}: Pick<IconProps, 'directory' | 'imageName'>) {
  if (!isClient()) return '';
  const svgPath = `Internet/Acquisition/US_en/AppContent/OneSite/Data/SVG/${directory}/${imageName}.svg`;
  return `${getStaticHost(window.location.hostname)}/${svgPath}`;
}

export const Icon = ({
  Component = 'div',
  imageName,
  directory,
  className,
  theme = {},
  $size = Size.MD,
  qeId,
  title,
}: IconProps) => (
  <ReactSVG
    aria-hidden={!title}
    title={title}
    className={classnames(
      styles.root,
      themeToClassNames(theme),
      modifiersToClassNames(styles, { $size }),
      className
    )}
    data-qe-id={qeId}
    src={getSvgPath({ directory, imageName })}
    wrapper={Component}
  />
);
